<script>
  import { onMount, onDestroy } from "svelte";
  import { array_move, getCollapseClass } from "../../Common/tools";
  import ColorPicker from "../../Common/ColorPicker.svelte";
  import LinkPicker from "../../Common/LinkPicker.svelte";
  import {External, M} from "../../external";

  export let data,
    isCollapsable = false,
    isCollapsed = false;

  let menu,
    jMenu,
    oldPosition,
    linkPicker = [];

  data.style.color = data.style.color || "#ffffff";

  function onAdd() {
    data.menu.push({ caption: "", link: "" });
    data = Object.assign({}, data, {});
  }

  function onDelete(idx) {
    data.menu.splice(idx, 1);
    data = Object.assign({}, data, {});
  }

  function onLinkClick(i) {
    linkPicker[i].select(data.menu[i]);
  }

  function onLinkSelected(e, i) {
    data.menu[i] = Object.assign({}, data.menu[i], { caption: e.caption, link: e.link });
  }

  function toggleCollapse() {
    if (isCollapsable) {
      isCollapsed = !isCollapsed;
    }
  }

  onMount(function () {
    jMenu = External.$(menu);
    jMenu.sortable({
      containment: "parent",
      handle: ".move-icon",
      create: function () {
        oldPosition = jMenu.sortable("toArray");
      },
      stop: function (e, ui) {
        const id = ui.item[0].id,
          newPosition = jMenu.sortable("toArray"),
          oldIndex = oldPosition.indexOf(id),
          newIndex = newPosition.indexOf(id);

        if (newIndex === -1 || oldIndex === -1) {
          oldPosition = newPosition;
          return;
        }

        data.menu = array_move(data.menu, oldIndex, newIndex);
        oldPosition = newPosition;
      }
    });
  });
  data.style.color = data.style.color || "#fffff";
  onDestroy(function () {
    jMenu.sortable("destroy");
  });
</script>

<div class="col20 f-left t-center mb-25 mt-15" on:click={toggleCollapse}><h4 class="t-left {getCollapseClass(isCollapsable, isCollapsed)}">{M.MENU_WIDGET_NAME}</h4></div>
{#if !isCollapsed}
  <div class="col20 f-left color-pick-wrap-widgets">
    <ColorPicker bind:color={data.style.color} label={M.COLOR} alpha="no" />
  </div>

  <div class="form-admin-style-2 mb-10 mt-15 f-left">
    <a class="middle-button with-icon blue mb-10" on:click={onAdd}>{M.ADD_MENU_ITEM}</a>
    <div class="menu" bind:this={menu}>
      {#each data.menu as item, i (item)}
        <div class="field col20 f-left" id={item.caption.replace(" ", "")}>
          <span class="move-icon flex-none button-tooltip" data-tooltip="simpleMove" />
          <input type="text" name="menuLinkItem" tabindex="0" class="label-field modify" bind:value={item.caption} placeholder={M.TITLE} style="max-width: 145px" />
          <div class="buttons-wrapper flex-none">
            <LinkPicker bind:this={linkPicker[i]} onComplete={(e) => onLinkSelected(e, i)} emailLinkPicker={true}>
              <a on:click|preventDefault={() => onLinkClick(i)} class="delete delete-icon light-gray-icon modify button-tooltip circle-effect">
                <i class="material-icons">link</i>
              </a>
            </LinkPicker>
            <a on:click|preventDefault={() => onDelete(i)} data-tooltip="simpleDelete" class="delete delete-icon light-gray-icon modify button-tooltip mr-10 circle-effect">
              <i class="material-icons">delete</i>
            </a>
          </div>
        </div>
      {/each}
    </div>
  </div>
{/if}
